@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

[data-fpsm-theme='oddschecker'],
[data-fpsm-theme='plus'],
[data-fpsm-theme='whoscored'],
[data-fpsm-theme='gazzetta'] {
  --comparison-right: initial;
  --comparison-progress: initial;
  --comparison-separator: initial;
}

[data-fpsm-theme='plus'] {
  --comparison-right: #c4ffce;
  --comparison-progress: #c4ffce;
}

[data-fpsm-theme='whoscored'] {
  --comparison-right: var(--cxy-color-surface-primary-default-subtle);
  --comparison-progress: #f4fcf0;
}

[data-fpsm-theme='gazzetta'] {
  --comparison-right: #000000;
  --comparison-progress: #59990f;
  --comparison-separator: #808080;
}

.comparisonContainer {
  width: 100%;
  border-radius: var(--cxy-border-radius-m);
  color: var(--cxy-color-text-default-placeholder);

  & + .comparisonContainer {
    margin-block-start: var(--cxy-spacing-3);
  }
}

.valuesContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: var(--cxy-spacing-xxxsm) 0;
}

.value .label {
  display: flex;
  align-items: center;
}

.value {
  @include cxy.font-size('text-s', var(--cxy-fontWeight-semiBold));

  .leftBadge {
    background-color: var(--cxy-color-brand);
    color: var(--cxy-color-text-default-placeholder);
  }

  .rightBadge {
    background-color: var(--comparison-right, #e5e5e5);
    color: var(--cxy-color-text-default-placeholder);
  }
}

.label {
  @include cxy.font-size('text-xs');
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-xxxsm);
  color: var(--cxy-color-text-default-body);
  padding-inline: var(--cxy-spacing-xxsm);
  text-align: center;

  @include cxy.screen-size('desktop') {
    @include cxy.font-size('text-m');
  }
}

.progressBarContainer {
  display: flex;
  width: 100%;
  height: 4px;
  border-radius: var(--cxy-border-radius-s);

  &.hasMiddleValue {
    margin-bottom: var(--cxy-spacing-sm);
  }
}

.progressBar {
  height: 100%;

  &.leftBar {
    background-color: var(--cxy-color-brand);
  }

  &.rightBar {
    background-color: var(--comparison-right, #e5e5e5);
  }
}

.progress {
  height: 100%;
}

.leftBar {
  border-top-left-radius: var(--cxy-border-radius-m);
  border-bottom-left-radius: var(--cxy-border-radius-m);
}

.rightBar {
  border-top-right-radius: var(--cxy-border-radius-m);
  border-bottom-right-radius: var(--cxy-border-radius-m);
}

.lowerValue .progress {
  background-color: var(--comparison-progress, #e8f9ed);
}

.separatorContainer {
  position: relative;
  width: 4px; // Fixed width when no middle value
  height: 100%;
  background-color: var(--comparison-separator, var(--cxy-color-surface-default));
}

.separator {
  width: 100%;
  height: 100%;
  background-color: var(--comparison-separator, var(--cxy-color-surface-default));
}

.middleBadge {
  position: absolute;
  background-color: var(--comparison-separator, var(--cxy-color-surface-default));
  color: var(--cxy-color-content-on-inverse);
  left: 0;
  top: var(--cxy-spacing-3);

  @include cxy.screen-size('desktop') {
    left: 50%;
    transform: translateX(-50%);
  }

  &.badgeRightAligned {
    right: 0;
    left: unset;
  }
}

.separatorWrapper {
  position: relative;
  height: 100%;
}
